module.exports = __webpack_public_path__ + "media/images/webpage/shared/sale/cover-1280x320-d5c95b13338a16b4c92387696d8e02e0.webp";